import { useState, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { IdCard } from "lucide-react";
import { ContentProvider, useContent } from "@/content/ContentContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { SectionLink } from "@/components/SectionLink";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { LegalOverlay } from "@/components/LegalOverlay";
import Admin from "@/pages/Admin";
import Portal from "@/pages/Portal";
import PublicProject from "@/pages/PublicProject";
import Visitenkarte from "@/pages/Visitenkarte";

const Home = () => {
  const [legal, setLegal] = useState(null);
  const content = useContent();

  useEffect(() => {
    document.title = content.seo.title;
    const setMeta = (name, value) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", value);
    };
    setMeta("description", content.seo.description);
    setMeta("keywords", content.seo.keywords);
  }, [content]);

  return (
    <ReactLenis root options={{ lerp: 0.09, anchors: true }}>
      <div className="min-h-screen overflow-x-clip bg-background font-body text-foreground">
        <Nav />
        <main>
          <Hero />
          <MarqueeStrip />
          <About />
          <SectionLink to="#leistungen" title="Leistungen" />
          <Services />
          <SectionLink to="#vorher-nachher" title="Vorher / Nachher" />
          <BeforeAfter />
          {content.marqueeBottom.enabled && (
            <MarqueeStrip items={content.marqueeBottom.items} />
          )}
          <Contact onOpenDatenschutz={() => setLegal("datenschutz")} />
        </main>
        <Footer
          onOpenImpressum={() => setLegal("impressum")}
          onOpenDatenschutz={() => setLegal("datenschutz")}
        />
        <Link
          to="/visitenkarte"
          aria-label="Digitale Visitenkarte öffnen"
          data-testid="visitenkarte-fab"
          className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 transition-all duration-300 hover:scale-110 hover:bg-foreground hover:text-background"
        >
          <IdCard className="h-6 w-6" />
          <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap border border-foreground/15 bg-background px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-foreground opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            Kontakt speichern
          </span>
        </Link>
        <LegalOverlay open={legal} onClose={() => setLegal(null)} />
      </div>
    </ReactLenis>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/visitenkarte" element={<Visitenkarte />} />
          <Route path="/p/:token" element={<PublicProject />} />
        </Routes>
      </ContentProvider>
    </BrowserRouter>
  );
}
